import React from 'react'
import config from '../../../../program-section-types-config.json'
import { Field, ErrorMessage } from 'formik';
import RadioButton from '../SingleSelectRadiobutton.jsx';
import RadioButtonGroup from '../RadioButtonGroup.jsx';
import Translation from '../../../Translation/cont/Translation';


const AddNewSectionTypes = ({hasShowtimes, setFieldValue, hasAdvertisements}) => {
    const {typeContent, activeTypes} = config
    let usedTypes = activeTypes

    if(!hasShowtimes) {
        usedTypes = _.without(activeTypes, 'showtimes')
    }
    if(!hasAdvertisements) {
        usedTypes = _.without(usedTypes, 'advertisement')
    }
    
    const allActiveTypes = usedTypes.map((typeID, index) => {
        const currentType = typeContent[typeID] 

        return <Field
            key={index}
            component={RadioButton}
            name="type"
            id={typeID}
            setFieldValue={setFieldValue}
            label={<Translation id={currentType.transId} />}
        />
    })

    return (
        <div>
            <RadioButtonGroup
                label="Type*"
                className="select-new-section-type">
                {allActiveTypes}
            </RadioButtonGroup>
            <ErrorMessage className="text-regular-color" name="type" component="div" />  
        </div>
    )
}

export default AddNewSectionTypes